
import './Teenused.css';
import {useState, useEffect} from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';

import { Button, Navbar, Container, Nav, NavDropdown, Card, Row, Col, Image, Table, ThemeProvider } from 'react-bootstrap';

export default function Hero() {

    return (
      <div className='main'>
        <Container>

        
          <Container style={{marginBottom:"2.5rem", fontWeight:"500", textAlign:"start", color:"#43ACE7",}}>
           <h1 style={{color:"#43ACE7", textAlign:"center"}}>
            <strong >Täiskasvanute Ortodontia</strong>
          </h1>
            <p style={{color:"#43ACE7", fontWeight:"500", textAlign:"start"}}></p>
            <h4 style={{ color: "#43ACE7", fontWeight: "500" }}>
        Esteetiline naeratuse kujundamine (Smile Design)
      </h4>
      <p>
        Terviklik lähenemine, mille käigus analüüsime hammaste kuju, asendit, proportsioone ja igemejoont ning loome personaalse plaani harmoonilise ja loomuliku naeratuse saavutamiseks.
      </p>
      <ul>
        <li>
          Kasutame digitaalseid lahendusi ja visuaalseid simulatsioone, et patsient näeks võimalikku tulemust juba enne ravi ning saaks teadlikult valida sobivaima kombinatsiooni ortodontiast, hammaste kuju korrigeerimisest ja valgendusest.
        </li>
        <li>
          <p>
            <strong>
              Hammaste valgendus
            </strong>
          </p>
          
          <p>
            ohutu ja tõhus protseduur, mis muudab hambad märgatavalt heledamaks ning taastab naeratuse värskuse ja sära.

Kasutame professionaalseid meetodeid, mis on hambasõbralikud ja annavad ühtlase, loomuliku tulemuse, sobides nii iseseisva protseduurina kui ka osana esteetilisest naeratuse kujundamisest. Nõustame valgenduse meetodi valikul.
          </p>
        </li>
        <li>
          <p>
            <strong>
              Täiskasvanute ortodontia
            </strong>
          </p>
          <p>
            Ortodontiline ravi ei ole ainult lastele – ka täiskasvanueas on võimalik hambumust korrigeerida ja naeratust parandada.
          </p>
        </li>
      </ul>
      </Container>
          </Container>

        </div>
    );
}